import script from "./collumnOptions.vue?vue&type=script&setup=true&lang=js"
export * from "./collumnOptions.vue?vue&type=script&setup=true&lang=js"

import "./collumnOptions.vue?vue&type=style&index=0&id=1bcbf5ad&lang=scss"

const __exports__ = script;

export default __exports__